import React from "react";
import "../styles/projects.scss";
import projectOne from "../images/cpm.png";
import projectTwo from "../images/dsb.png";
import projectThree from "../images/prt2.png";
import projectFour from "../images/prt1.png";
import projectFive from "../images/sofi-travel.png";
import { BiLinkExternal } from "react-icons/bi";
import { FiGithub } from "react-icons/fi";
import HashLoader from "react-spinners/HashLoader";
export default function Project() {
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return loading ? (
    <HashLoader
      className="loader"
      size={150}
      color={"#0a192f"}
      loading={loading}
    />
  ) : (
    <div className="projects-page-container">
      <div>
        <h1 className="projects-header">some things I've built</h1>
        <div className="projects-header-devider"></div>
        <p className="projects-page-description">
          I've worked on the following development project in the past. Wish to
          see more? I'm working on some excellent projects, and this page will
          feature all of my most recent and fantastic project portfolios.
        </p>
      </div>

      {/* Project One */}
      <div className="projects-container">
        <div className="project-one">
          <div className="project-description-container">
            <div>
              <p className="featured">Featured Project</p>
              <h2 className="project-title">Construction Company Website & Cross-Platform Application</h2>
              <h3 className="project-subtitle">Construction Company Website Application</h3>
            </div>
            <p className="project-description">
               Built a modern construction company web and mobile application featuring a responsive dashboard, project portfolio with image galleries, project catalog, blog page, and advertisement management. Developed using React, Tailwind CSS, Node.js, PostgreSQL, Cloudinary, Elementor, and Capacitor to deliver a seamless experience across desktop and mobile platforms with optimized media storage and content management.
            </p>
            <div className="techs">
              <p className="project-techs">Express</p>
              <p className="project-techs">React</p>
              <p className="project-techs">postgresql</p>
              <p className="project-techs">tailwindcssCSS</p>
            </div>
            <div className="links">
              <a
                href="https://web-app-k6c3.onrender.com/"
                target="blank"
                className="project-links"
              >
                <BiLinkExternal style={{ textDecoration: "none" }} />
              </a>
              <a
                href="https://github.com/capit-sofi"
                target="blank"
                className="project-links"
              >
                <FiGithub />
              </a>
            </div>
          </div>
        </div>

        <div className="project-image-container">
          <a target="blank" href="https://web-app-k6c3.onrender.com/">
            <img src={projectOne} className="project-img" alt="" />
          </a>
        </div>
      </div>

      {/* Project two */}
      <div className="projects-container">
        <div className="project-image-container">
          <a target="blank" href="https://dashbord-nbiz.onrender.com">
            <img src={projectTwo} className="project-img" alt="" />
          </a>
        </div>
        <div className="project-one">
          <div className="project-description-container">
            <div>
              <p className="featured">Featured Project</p>
              <h2 className="project-title">Dash-board</h2>
              <h3 className="project-subtitle"> Construction Company Website & Cross-Platform Application</h3>
            </div>
            <p className="project-description">
              A cross-platform construction management dashboard designed to efficiently control and monitor construction operations from a single platform. It enables real-time tracking of projects, resources, and site activities, ensuring smooth coordination, better decision-making, and improved workflow across web and mobile devices.
            </p>
            <div className="techs">
              <p className="project-techs">react</p>
              <p className="project-techs">tailwindcss</p>
              <p className="project-techs">PostgreSQL</p>
              
            </div>
            <div className="links">
              <a
                href="https://dashbord-nbiz.onrender.com"
                target="blank"
                className="project-links"
              >
                <BiLinkExternal style={{ textDecoration: "none" }} />
              </a>
              <a
                href="https://github.com/capit-sofi"
                target="blank"
                className="project-links"
              >
                <FiGithub />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Project Three */}
      <div className="projects-container">
        <div className="project-one">
          <div className="project-description-container">
            <div>
              <p className="featured">Featured</p>
              <h2 className="project-title">3D professional portfolio website</h2>
              <h3 className="project-subtitle">
                3D professional portfolio website
              </h3>
            </div>
            <p className="project-description">
              A modern **3D professional portfolio website** designed to showcase projects and skills through an interactive and visually engaging experience. Built with smooth animations and 3D elements, it delivers a unique user experience while highlighting creativity, technical expertise, and professional work in a clean and responsive layout across all devices.

            </p>
            <div className="techs">
              <p className="project-techs">react</p>
              <p className="project-techs">Tailwind</p>
              <p className="project-techs">3js</p>
            </div>
            <div className="links">
              <a
                href="https://samuel-s.netlify.app/"
                target="blank"
                className="project-links"
              >
                <BiLinkExternal style={{ textDecoration: "none" }} />
              </a>
              <a
                href="https://github.com/capit-sofi"
                target="blank"
                className="project-links"
              >
                <FiGithub />
              </a>
            </div>
          </div>
        </div>

        <div className="project-image-container">
          <a target="blank" href="https://samuel-s.netlify.app/">
            <img src={projectThree} className="project-img" alt="" />
          </a>
        </div>
      </div>

       {/* Project four*/}
       <div className="projects-container">
        <div className="project-image-container">
          <a target="blank" href="https://sofoniyas-b.netlify.app/">
            <img src={projectFour} className="project-img" alt="" />
          </a>
        </div>
        <div className="project-one">
          <div className="project-description-container">
            <div>
              <p className="featured">Featured</p>
              <h2 className="project-title">professional portfolio website</h2>
              <h3 className="project-subtitle"> professional portfolio website</h3>
            </div>
            <p className="project-description">
              A **professional portfolio website** designed to showcase projects, skills, and experience in a clean and modern layout. It highlights work in a structured and visually appealing way, ensuring easy navigation and a strong first impression. Fully responsive and optimized for performance, it reflects creativity, professionalism, and technical expertise.

            </p>
            <div className="techs">
              <p className="project-techs">React</p>
              <p className="project-techs">Tailwindcss</p>
              <p className="project-techs">Framer-motion</p>
              
            </div>
            <div className="links">
              <a
                href="https://sofoniyas-b.netlify.app/"
                target="blank"
                className="project-links"
              >
                <BiLinkExternal style={{ textDecoration: "none" }} />
              </a>
              <a
                href="https://github.com/capit-sofi"
                target="blank"
                className="project-links"
              >
                <FiGithub />
              </a>
            </div>
          </div>
        </div>
      </div>
       {/* Project five */}
       <div className="projects-container">
        <div className="project-one">
          <div className="project-description-container">
            <div>
              <p className="featured">Featured Project</p>
              <h2 className="project-title">sofi-travel</h2>
              <h3 className="project-subtitle">A travel web app</h3>
            </div>
            <p className="project-description">
               is a travel web app. it is atractive, beautifull, simple, effective and efficient created by html, css, js and bootstrap5
            </p>
            <div className="techs">
              <p className="project-techs">Bootstrap5</p>
              <p className="project-techs">Html5</p>
              <p className="project-techs">Js</p>
              <p className="project-techs">CSS</p>
            </div>
            <div className="links">
              <a
                href="https://sofi-travel.netlify.app"
                target="blank"
                className="project-links"
              >
                <BiLinkExternal style={{ textDecoration: "none" }} />
              </a>
              <a
                href="https://github.com/capit-sofi"
                target="blank"
                className="project-links"
              >
                <FiGithub />
              </a>
            </div>
          </div>
        </div>

        <div className="project-image-container">
          <a target="blank" href="https://sofi-travel.netlify.app">
            <img src={projectFive} className="project-img" alt="" />
          </a>
        </div>
      </div>

    </div>
  );
}
